import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e32a6f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "element",
  class: "head-toolbar"
}

import { CompositeHeadApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'head-toolbar',
  props: {
    expanded: { type: Boolean },
    model: {}
  },
  emits: ["expand", "collapse"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function expand() {
  emit("expand");
}

function collapse() {
  emit("collapse");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.expanded)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "head-toolbar-button expand-button glyphicon glyphicon-fullscreen",
          onClick: expand
        }))
      : _createCommentVNode("", true),
    (props.expanded)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "head-toolbar-button collapse-button glyphicon glyphicon-resize-small",
          onClick: collapse
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})